import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import NotAuthorized from '../not-authorized/not-authorized';

const mapStateToProps = state => ({
  user: state.user.logged,
});

export default connect(mapStateToProps)(
  ({ component: Component, props: cProps, user, adminOnly, ...rest }) => {
    const getContent = props => {
      if (adminOnly) {
        switch (user.isAdmin) {
          case false:
            return <NotAuthorized />;
          case true:
            return <Component {...props} {...cProps} />;
          default:
            return '';
        }
      }

      return <Component {...props} {...cProps} />;
    };

    return (
      <Route
        {...rest}
        render={props =>
          cProps.token ? (
            getContent(props)
          ) : (
            <Redirect
              to={`/login?redirect=${props.location.pathname}${
                props.location.search
              }`}
            />
          )
        }
      />
    );
  }
);



// WEBPACK FOOTER //
// ./src/components/wrappers/auth-route.js